import React from "react";
import * as S from './StarRatingStyles'
import { WHITE_STAR_URL } from "../../../../../config/constants";

const StarRating = ({
  value
}) => {
  return (
    <S.StarRating>
      <S.Rating>{value}</S.Rating>
      <S.StarContainer>
        <S.StarImg src={WHITE_STAR_URL} alt="star" />
      </S.StarContainer>
    </S.StarRating>
  );
};

export default StarRating;